import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=32671693&scoped=true&"
import script from "./FontSelect.vue?vue&type=script&lang=ts&"
export * from "./FontSelect.vue?vue&type=script&lang=ts&"
import style0 from "./FontSelect.vue?vue&type=style&index=0&id=32671693&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32671693",
  null
  
)

export default component.exports